import React from 'react';
import {
  QuestionCircleOutlined,
  CalculatorOutlined,
  GlobalOutlined,
  EditOutlined,
  MailOutlined,
  CustomerServiceOutlined,
  FileSearchOutlined,
  FilePdfOutlined,
  FileTextOutlined,
  FileMarkdownOutlined,
  PictureOutlined,
  LinkOutlined,
  PartitionOutlined,
} from '@ant-design/icons';
import { TOOL_LIST } from './toolsList';
import type { ToolListEntry } from './toolsList';

/** The single source of truth for the free-tools list: index cards, the
 *  per-tool sidebar nav and the footer all render from this. The list itself
 *  (paths, order, docs anchors) lives in toolsList.mjs so the plain-Node SEO
 *  prerenderer can read it too; this module only adds the React icons.
 *  Labels come from the existing portal.tools.<key>CardTitle i18n keys. */
export interface ToolEntry extends ToolListEntry {
  icon: React.ReactNode;
}

const ICONS: Record<string, React.ReactNode> = {
  keigo: <EditOutlined />,
  apology: <MailOutlined />,
  proofread: <FileSearchOutlined />,
  inquiry: <CustomerServiceOutlined />,
  pdfsum: <FilePdfOutlined />,
  pdftext: <FileTextOutlined />,
  pdfmd: <FileMarkdownOutlined />,
  ogp: <PictureOutlined />,
  link: <LinkOutlined />,
  sitemap: <PartitionOutlined />,
  faq: <QuestionCircleOutlined />,
  roi: <CalculatorOutlined />,
  crawl: <GlobalOutlined />,
};

export const TOOLS: ToolEntry[] = TOOL_LIST.map((tool) => ({ ...tool, icon: ICONS[tool.key] }));
